import { DeliveryServicesReq } from "@app/modules/create-order/entities/create-order.entities";
import {
  AcceptPendingOrderBody,
  ActiveListOrder,
  ActiveOrderQueryParams,
  ArchivedListOrder,
  ArchivedOrderQueryParams,
  BoxPendingOrder,
  DetailOrder,
  OrdersState,
  OrdersType,
  SearchOrderQueryParams,
} from "@app/modules/orders/entities/orders.entities";
import { PickingPoint } from "@core/entities";
import { AdapterUi } from "@core/store/adapters/global.adapter";
import { createAction, props } from "@ngrx/store";
import { ListOrder } from "../reducers/order-reducer";

export enum OrdersAction {
  CancelOrder = "[ORDERS] Cancel order",
  Empty = "[ORDERS] Empty",
  ExportOrders = "[ORDERS] Export Orders",
  FetchOrderDetail = "[ORDERS] Fetch Order by Id",
  InputSearch = "[ORDERS] Search Input",
  SetSelectedOrder = "[ORDERS] Set Selected Order",

  // Active
  NotifyDeliveredProducts = "[ORDERS] Notify delivered products to RT",
  ClearAllActiveOrders = "[ORDERS] Clear all Active orders",
  FetchActiveOrderList = "[ORDERS] Fetch Active Order list",
  SetActiveOrdersList = "[ORDERS] Set Active Orders List",
  NotifyOrderReady = "[ORDERS] Notify Order Ready",

  // Archived
  RemoveDebt = "[ORDERS] Remove Debt From Order",
  FetchArchivedOrderList = "[ORDERS] Fetch Archived Order list",
  SetArchivedOrderList = "[ORDERS] Set Archived Orders List",

  // Pending
  AcceptPendingOrder = "[ORDERS] Accept Pending Orders",
  FetchPendingOrderList = "[ORDERS] Fetch Pending Order list",
  SetPendingOrderList = "[ORDERS] Set Pending Orders List",

  // Box Pending
  FetchBoxPendingOrderList = "[ORDERS] BOX Fetch Pending Order list",
  SetBoxPendingOrdersSelectedPickingPoint = "[ORDERS] BOX Set Pending Orders Picking Point",
  SetBoxPendingOrdersList = "[ORDERS] BOX Set Pending Orders List",
  AcceptBoxPendingOrder = "[ORDERS] BOX Accept Pending Order",
  SetBoxSelectedPendingOrder = "[ORDERS] BOX Set Selected Pending Order",

  ToggleOrdersType = "[ORDERS] Toggle between archived and active orders",
  UiOrders = "[ORDERS] Orders UI",
  GetOrderCreationBody = "[ORDERS] Get Order Creation Body",
  CheckFleetAvailability = "[ORDERS] Check fleet availability",
  DuplicateOrder = "[ORDERS] Duplicate order",
  SetOrderDuplication = "[ORDERS] Set order duplication",
  SetChildOrders = "[ORDERS] Set child orders",
}

export const uiOrders = createAction(OrdersAction.UiOrders, props<{ ui: Array<AdapterUi<OrdersState["ui"]>> }>());
export const Empty = createAction(OrdersAction.Empty);
export const inputSearch = createAction(OrdersAction.InputSearch, props<SearchOrderQueryParams>());

// order duplication
export const getOrderCreationBody = createAction(OrdersAction.GetOrderCreationBody, props<{ payload: string }>());
export const setChildOrders = createAction(OrdersAction.SetChildOrders, props<{ payload: ListOrder[] }>());
export const checkFleetAvailability = createAction(OrdersAction.CheckFleetAvailability, props<{ payload: DeliveryServicesReq }>());
export const setOrderDuplication = createAction(
  OrdersAction.CheckFleetAvailability,
  props<{ payload: Partial<OrdersState["orderDuplication"]> }>()
);
export const duplicateOrder = createAction(
  OrdersAction.DuplicateOrder,
  props<{ payload: { body: any; totalValue: number; parentOrderId: string } }>()
);

// active orders
export const clearAllActiveOrders = createAction(OrdersAction.ClearAllActiveOrders);
export const fetchActiveOrderList = createAction(OrdersAction.FetchActiveOrderList, props<ActiveOrderQueryParams>());
export const setActiveOrdersList = createAction(OrdersAction.SetActiveOrdersList, props<{ payload: ActiveListOrder[] }>());
export const notifyDeliveredProducts = createAction(OrdersAction.NotifyDeliveredProducts, props<{ rappiId: string; cargoId: string }>());
export const notifyOrderReady = createAction(OrdersAction.NotifyOrderReady, props<{ rappiId: string; cargoId: string }>());
export const cancelOrder = createAction(OrdersAction.CancelOrder, props<{ orderId: string; pickingPointId: number; reason?: string }>());

// archived orders
export const fetchArchivedOrderList = createAction(OrdersAction.FetchArchivedOrderList, props<ArchivedOrderQueryParams>());
export const setArchivedOrdersList = createAction(OrdersAction.SetArchivedOrderList, props<{ payload: ArchivedListOrder[] }>());
export const removeDebt = createAction(OrdersAction.RemoveDebt, props<{ payload: string }>());

// pending orders
export const fetchPendingOrderList = createAction(OrdersAction.FetchPendingOrderList, props<ArchivedOrderQueryParams>());
export const setPendingOrdersList = createAction(OrdersAction.SetPendingOrderList, props<{ payload: ActiveListOrder[] }>());
export const acceptPendingOrder = createAction(OrdersAction.AcceptPendingOrder, props<AcceptPendingOrderBody>());

// BOX Pending orders
export const setBoxPendingOrdersList = createAction(OrdersAction.SetBoxPendingOrdersList, props<{ payload: BoxPendingOrder[] }>());
export const acceptBoxPendingOrders = createAction(
  OrdersAction.AcceptBoxPendingOrder,
  props<{ orderId: string; pickingPointId: number }>()
);
export const fetchBoxPendingOrdersList = createAction(OrdersAction.FetchBoxPendingOrderList, props<{ payload: number }>());
export const setBoxPendingOrdersSelectedPickingPoint = createAction(
  OrdersAction.SetBoxPendingOrdersSelectedPickingPoint,
  props<{ payload: PickingPoint; retailerId: number }>()
);
export const setBoxSelectedPendingOrder = createAction(OrdersAction.SetBoxSelectedPendingOrder, props<{ payload: BoxPendingOrder }>());

// shared
export const fetchOrderDetail = createAction(
  OrdersAction.FetchOrderDetail,
  props<Partial<{ cargo_order_id: string; rappi_order_id: string }>>()
);
export const setSelectedOrder = createAction(OrdersAction.SetSelectedOrder, props<{ payload: DetailOrder }>());
export const toggleOrdersType = createAction(OrdersAction.ToggleOrdersType, props<{ payload: OrdersType }>());
export const exportOrders = createAction(OrdersAction.ExportOrders);
